<template>
	<div class="bg-dark py-4 z-2 position-relative">
        <div class="row g-0 h-100 d-flex">
            <div class="col-9 p-5 d-none d-lg-flex">
            </div>
            <div class="col col-lg-3 d-flex flex-column align-items-center justify-content-center">
                <a href="#home"><i class="fs-1 bi bi-arrow-up-square-fill text-white"></i></a>
                <small class="fw-normal text-white">To top</small>
            </div>
        </div>
    </div>
</template>